import React from 'react';
import { Button } from 'primereact/button';
import { useTheme } from '../contexts/ThemeContext';

export const ThemeSwitcher = ({ className = '' }) => {
    const { theme, toggleTheme } = useTheme();

    return (
        <Button
            icon={theme === 'dark' ? 'pi pi-sun' : 'pi pi-moon'}
            className={`theme-switcher ${className}`}
            onClick={toggleTheme}
            rounded
            text
            severity="secondary"
            aria-label={`Alternar para tema ${theme === 'dark' ? 'claro' : 'escuro'}`}
            title={`Tema ${theme === 'dark' ? 'claro' : 'escuro'}`}
        />
    );
};

export default ThemeSwitcher;
